import React from "react";

interface Props {
  delivery_discount_message: string;
}

export default function DeliveryDiscountCard({
  delivery_discount_message,
}: Props) {
  return (
    <div className="tf-mini-cart-item">
      {/* image box */}
      <div className="tf-mini-cart-image">
        <div style={{ width: "80px", height: "80px" }}>
          <img
            src="/images/delivery.png"
            alt="Delivery"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>
      </div>

      {/* text box */}
      <div className="tf-mini-cart-info">
        <div className="title" style={{ fontSize: "14px", lineHeight: "20px",marginTop:"20px" }}>
          {delivery_discount_message}
        </div>
        
      </div>
    </div>
  );
}
